/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CheckSquareCutIcon24Regular = forwardRef('CheckSquareCutIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.75 6.5A2.75 2.75 0 0 1 6.5 3.75H14a.75.75 0 0 0 0-1.5H6.5A4.25 4.25 0 0 0 2.25 6.5v11a4.25 4.25 0 0 0 4.25 4.25h11a4.25 4.25 0 0 0 4.25-4.25V13a.75.75 0 0 0-1.5 0v4.5a2.75 2.75 0 0 1-2.75 2.75h-11a2.75 2.75 0 0 1-2.75-2.75v-11Z" }),
        React.createElement("path", { d: "M21.343 5.968a.75.75 0 0 0-1.06-1.06l-8.05 8.048c-.44.44-1.152.44-1.591 0L7.655 9.97a.75.75 0 0 0-1.06 1.06l2.986 2.987a2.625 2.625 0 0 0 3.713 0l8.049-8.05Z" })));
});
